// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBESYMfI0B8tvDEz5OAHL1GLVEtuMnS27Y",
  authDomain: "capstone-f7d2c.firebaseapp.com",
  projectId: "capstone-f7d2c",
  storageBucket: "capstone-f7d2c.appspot.com",
  messagingSenderId: "598231360306",
  appId: "1:598231360306:web:466f7f2668bf19477ead2b",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
